import styled, { createGlobalStyle } from 'styled-components'

import { Colors } from '@utils/Colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 6vh;
`

export const DocumentGlobalStyles = createGlobalStyle`
  .K7zjJJJ88Kzy6HzkZ9H6 {
    color: ${Colors.PRIMARY500} !important;
    font-family: Inter, sans-serif !important;
  }

  .GVRYtuaeMQhmyJUlgSKw,
  .GVRYtuaeMQhmyJUlgSKw *,
  .rkNLAMaq0y6l2Kaywz2X,
  .rkNLAMaq0y6l2Kaywz2X *,
  .anROHlyIqVW5_upeTPVh,
  .anROHlyIqVW5_upeTPVh *,
  .uHxNEMzovYZko2lWqYV2,
  .uHxNEMzovYZko2lWqYV2 * {
    font-family: 'Inter', sans-serif !important;
  }

  #exp_preview-primary-button {
    background-color: ${Colors.PRIMARY500} !important;
  }

  #screen #exp_capture-title {
    background-color: transparent !important;
    color: #FFFFFF !important;
  }

  @media (hover: hover) and (pointer: fine) {
    #cameraPreview {
      transform: scaleX(-1) !important;
    }
  }

`
